module.exports = __webpack_public_path__ + "static/media/enterprise.a2f933d7.png";